var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.041 0 0 4.041 0 9C0 13.959 4.041 18 9 18C13.959 18 18 13.959 18 9C18 4.041 13.959 0 9 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92114 4.92261C5.18474 4.65901 5.61213 4.65901 5.87573 4.92261L13.0757 12.1226C13.3393 12.3862 13.3393 12.8136 13.0757 13.0772C12.8121 13.3408 12.3847 13.3408 12.1211 13.0772L4.92114 5.8772C4.65754 5.6136 4.65754 5.18621 4.92114 4.92261Z",
    fill: "#EE443F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0696 4.92261C13.3332 5.18621 13.3332 5.6136 13.0696 5.8772L5.86958 13.0772C5.60597 13.3408 5.17859 13.3408 4.91498 13.0772C4.65138 12.8136 4.65138 12.3862 4.91498 12.1226L12.115 4.92261C12.3786 4.659 12.806 4.659 13.0696 4.92261Z",
    fill: "#EE443F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRejected);
export default __webpack_public_path__ + "static/media/XRejected.f1d0d99bafa65dcab236935718c44564.svg";
export { ForwardRef as ReactComponent };